import { ActiveCampaignSettingsInterface } from 'modules/profile/integrations/active-campaign-integration/types/active-campaign-settings-interface'
import httpClient from 'shared/utils/http-client'

export const ACTIVE_CAMPAIGN_SETTINGS_API = '/api/dashboard/customer/settings/active-campaign'

export const updateActiveCampaignSettings = (data: ActiveCampaignSettingsInterface) =>
  httpClient.put(ACTIVE_CAMPAIGN_SETTINGS_API, data)
